import { IXandrNativeAdObject } from "@almamedia/amr-adtech-stack/lib/services/ads";
import { titleLimit, attachSocialMediaClickTracker } from "@almamedia/amr-adtech-stack/lib/services/native/native-helpers";

function nativeFbConditions(adObj: IXandrNativeAdObject): boolean {
  return !!(
    adObj &&
    adObj.native &&
    adObj.native.body &&
    adObj.native.displayUrl &&
    adObj.native.title &&
    adObj.native.sponsoredBy &&
    adObj.native.desc2
  );
}

const nativeFbAd = {
  name: "native_fb_ad",
  buildContent: (adObj: IXandrNativeAdObject, wrapperId: string): string => {
    const { native } = adObj;
    let nativeContent = "";

    const title = native.title ?? "";
    let body = native.body ?? null;
    const sponsoredBy = native.sponsoredBy ?? "";
    const displayUrl = native.displayUrl ?? "";
    const additionalDescription = native.desc2 ?? "";
    const cta = native.cta ?? "";
    const imageUrl = native.image?.url;
    const iconUrl = native.icon?.url;
    const videoContent = native.video?.content;

    if (title.length > titleLimit) {
      body = null;
    }

    // HTML nativeContent
    const titleFb = title ? title.substring(0, 50) : "";
    const sponsoredByFb = sponsoredBy ? sponsoredBy.substring(0, 50) : "";
    const displayUrlFb = displayUrl ? displayUrl.substring(0, 100) : "";
    const additionalDescriptionFb = additionalDescription
      ? additionalDescription.substring(0, 75)
      : "";
    const ctaFb = cta ? cta.substring(0, 18) : "";
    const displayUrlFbNoProtocol = displayUrlFb.replace(/^https?:\/\//i, "");

    nativeContent =
      `<div id="${wrapperId}" class="${wrapperId}_sizing">` +
      `					<div id="${wrapperId}_body">` +
      `						<div id="${wrapperId}_upper_wrapper">` +
      `							<div id="${wrapperId}_header">` +
      `									<img id="${wrapperId}_headerIcon" src="${iconUrl}">` +
      `									<div id="${wrapperId}_headerRightSpace">` +
      `                 	<div id="${wrapperId}_sponsoredBy">${sponsoredByFb}</div>` +
      `               	<div id="${wrapperId}_adText">Mainos</div>` +
      `             	</div>` +
      `           	</div>` +
      `						</div>` +
      `						<div id="${wrapperId}_bodyText">${body}</div>`;
    if (videoContent) {
      nativeContent +=
        `<div id="${wrapperId}_almavideo-native" class="alma-nativevideo-player"></div>`;
    } else {
      nativeContent += `<img id="${wrapperId}_headerImage" src="${imageUrl}">`;
    }
    if (ctaFb) {
      nativeContent +=
        `<div id="${wrapperId}_footer">` +
        `           	<div id="${wrapperId}_footerLeftSpace">` +
        `             	<div id="${wrapperId}_displayUrl">${displayUrlFbNoProtocol}</div>` +
        `               	<div id="${wrapperId}_title">${titleFb}</div>` +
        `               	<div id="${wrapperId}_desc2">${additionalDescriptionFb}</div>` +
        `            	</div>` +
        `							<div id="${wrapperId}_footerRightSpace">` +
        `						 		<div id="${wrapperId}_buttonCta">${ctaFb}</div>` +
        `							</div>` +
        `						</div>`;
    } else {
      nativeContent +=
        `<div id="${wrapperId}_footer">` +
        `   <div id="${wrapperId}_footerSpace">` +
        `     <div id="${wrapperId}_displayUrl">${displayUrlFbNoProtocol}</div>` +
        `     	<div id="${wrapperId}_title">${titleFb}</div>` +
        `     <div id="${wrapperId}_desc2">${additionalDescriptionFb}</div>` +
        `   </div>` +
        `</div>`;
    }
    nativeContent += "</div></div>";

    return nativeContent;
  },
  buildStyles: (wrapperId: string): string => {
    return `#${wrapperId}{font-family:Helvetica,Arial,sans-serif;cursor:pointer;clear:both;text-align:left;border:1px solid #e4e2e2}.${wrapperId}_sizing{box-sizing:border-box}#${wrapperId}_upper_wrapper{background-color:#fff}#${wrapperId}_header{display:flex;padding:5px}#${wrapperId}_headerIcon{max-width:50px;max-height:50px}#${wrapperId}_headerRightSpace{display:flex;width:100%;align-items:center;justify-content:center;padding:0 10px}#${wrapperId}_sponsoredBy{font-size:21px;font-weight:700;margin:0;flex-grow:1}#${wrapperId}_adText{color:grey;font-size:14.4px;text-transform:uppercase;font-weight:700}#${wrapperId}_bodyText{padding:10px;font-size:16.7px;background-color:#fff;line-height:1.3333}#${wrapperId}_headerImage{display:flex;width:100%}#${wrapperId}_footer{display:flex;align-items:center;padding:10px;background-color:#efeff0}#${wrapperId}_footerSpace{width:100%}#${wrapperId}_footerLeftSpace{width:64%}#${wrapperId}_displayUrl{font-size:14px;color:grey;text-transform:uppercase;margin-bottom:8px;line-height:1.2308}#${wrapperId}_title{color:#000;font-size:17px;font-weight:700;margin-bottom:6px}#${wrapperId}_desc2{color:#000;font-size:15px}#${wrapperId}_footerRightSpace{width:36%;margin-left:10px}#${wrapperId}_buttonCta{border:2px solid #b2b4b4;border-radius:3px;color:#000;padding:10px;text-align:center;text-decoration:none;background-color:#fff;font-weight:600;font-size:15px}@media only screen and (min-width:768px){#${wrapperId}_bodyText{font-size:20px}#${wrapperId}_sponsoredBy{font-size:23px}#${wrapperId}_adText{font-size:15px}#${wrapperId}_displayUrl{font-size:15px}#${wrapperId}_title{font-size:18px}#${wrapperId}_desc2{font-size:17px}#${wrapperId}_footerLeftSpace{width:75%}#${wrapperId}_footerRightSpace{width:30%;margin-left:20px}}`;
  },
  attachClick: attachSocialMediaClickTracker,
};

export { nativeFbAd, nativeFbConditions };
